import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { InventoryStatusMessageTheme } from '../../../theme/default-theme';
import { Body2 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import { ITranslationsCollection, translate } from 'elc-service';
import { InventoryStatus } from '../../constants/InventoryStatuses';

export interface IInventoryStatusMessageConfig {
    showToosTitle?: boolean;
    showToosMessage?: boolean;
}
export interface IInventoryStatusMessage {
    config: IInventoryStatusMessageConfig;
    translations?: ITranslationsCollection;
    inventoryStatus: string;
    className?: string;
}

const StyledMessageBlock = styled.div`
    margin: ${ContentSpacing.space24} 0;
`;

const StyledMessageBody = styled(Body2)`
    ${InventoryStatusMessageTheme};
`;

export const InventoryStatusMessage = translate(['tempOutOfStockLabel', 'tempOutOfStockMessage'])(
    observer((props: IInventoryStatusMessage) => {
        const inventoryStatusMessageClassNames = classnames(
            'elc-add-to-bag-sku-inventory-status-message',
            'js-add-to-bag-sku-inventory-status-message',
            props.className
        );
        const inventoryStatusMessageMessageClassNames = classnames(
            'elc-add-to-bag-sku-inventory-status-message-message',
            'js-add-to-bag-sku-inventory-status-message-message'
        );

        const {
            tempOutOfStockLabel,
            tempOutOfStockMessage
        } = props.translations as ITranslationsCollection;
        const { config, inventoryStatus } = props;

        const appliedTempOutOfStockLabel = config.showToosTitle ? tempOutOfStockLabel : null;
        const appliedTempOutOfStockMessage = config.showToosMessage ? tempOutOfStockMessage : null;

        const statusMapping: { [k: string]: string[] } = {
            [InventoryStatus.TempOutOfStock]: [
                appliedTempOutOfStockLabel,
                appliedTempOutOfStockMessage
            ]
        };
        const statusMessage = statusMapping[inventoryStatus];

        const message = statusMessage && statusMessage[0];

        if (message) {
            return (
                <StyledMessageBlock className={inventoryStatusMessageClassNames}>
                    <StyledMessageBody className={inventoryStatusMessageMessageClassNames}>
                        {message}
                    </StyledMessageBody>
                </StyledMessageBlock>
            );
        } else {
            return null;
        }
    })
);
